import React, { useEffect, useState, Suspense } from 'react';
import Routes from './routes';


var jwtDecode = require('jwt-decode');



const App = (props)=>{

  return (
     <Routes/>
  );
}


export default App;
// export default withTranslation()(App);
